import EventDraftsScene from './EventDraftsScene'
export default EventDraftsScene